import ApiClient from '@/helpers/api-client/ApiClient'

export default {
  methods: {
    getTranslations () {
      ApiClient.getTranslations({
        viewName: this.$route.name
      }).then(response => {
        const data = response.data.data
        const lang = Object.keys(data)[0]
        this.$i18n.locale = lang
        localStorage.setItem('language', lang)
        this.$i18n.setLocaleMessage(lang, data[lang])
      }).then(() => {
        this.hidePreloader()
      })
    }
  }
}
